import Vue from 'vue'
import Vuex from 'vuex'

const debug = process.env.NODE_ENV !== 'production'

import createLogger from 'vuex/dist/logger'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
  },
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js